// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../config/styles';

const styles = theme => ({
  root: {
    margin: '15px 0',
    zIndex: 10,
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down(700)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  oneItemRow: {
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down(700)]: {
      justifyContent: 'center',
    },
  },
  inputMarginRight: {
    marginRight: 10,
  },
  changePasswordContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  changePasswordLines: {
    width: '35%',
    borderBottomColor: 'grey',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    [theme.breakpoints.down(700)]: {
      width: '30%',
    },
    [theme.breakpoints.down(450)]: {
      width: '20%',
    },
  },
  changePasswordText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  marginTop: {
    marginTop: 15,
  },
  buttonStyle: {
    margin: '15px auto',
  },
  errorText: {
    color: GlobalStyles.color.COLOR_REJECT,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  successText: {
    color: GlobalStyles.color.COLOR_GREEN,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
  },
  rejectedColor: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
  checkboxContainer: {
    display: 'flex',
    [theme.breakpoints.down(700)]: {
      justifyContent: 'center',
      marginBottom: 10,
    },
  },
  checkboxSubContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(700)]: {
      width: 290,
    },
  },
  checkbox: {
    display: 'flex',
    position: 'relative',
    margin: '10px 10px 10px 0',
  },
  checkboxLabel: {
    color: GlobalStyles.color.COLOR_GREY,
    display: 'flex',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    margin: 0,
  },
  passwordHelper: {
    width: 290,
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
});

export default styles;
